import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useScreen = () => {
  const theme = useTheme();
  const { mobile } = theme.breakpoints.values;

  const isMobile = useMediaQuery(`(max-width:${mobile - 1}px)`, { noSsr: true });
  const isDesktop = useMediaQuery(`(min-width:${mobile}px)`, { noSsr: true });

  let currentScreen = null;

  switch (true) {
    case isMobile:
      currentScreen = 'mobile';
      break;
    default:
      currentScreen = 'desktop';
      break;
  }

  return { currentScreen, isMobile, isDesktop };
};

export default useScreen;

export const initializeWindowSize = () => {
  const initialVh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${initialVh}px`);

  window.addEventListener('resize', () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
};



// WEBPACK FOOTER //
// ./src/hooks/useScreen.js